export default __webpack_public_path__ + "static/fonts/BrotherHome.28c8058.woff";